import type { AiClientInterface, QuickBlastParams, MessageHubSuggestionsParams } from './aiClient.types';
import BaseClient from '../BaseClient';

export default class CorporateAiClient extends BaseClient implements AiClientInterface {
    constructor(private teamId: number) {
        super();
    }

    quickBlastSuggestions(params: QuickBlastParams) {
        const url = `/api/v3/teams/${this.teamId}/ai/quick-blast`;
        return this.makeCoreApiRequest(url, 'post', params);
    }

    quickBlastFollowUp(campaignId: number) {
        const url = `/api/v3/teams/${this.teamId}/ai/quick-blast/${campaignId}/follow-up`;
        return this.makeCoreApiRequest(url, 'post');
    }

    messageHubSuggestions(params: MessageHubSuggestionsParams) {
        const url = `/api/v3/teams/${this.teamId}/ai/message`;
        return this.makeCoreApiRequest(url, 'post', params);
    }
}
